"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import React from "react";
import { observer } from "mobx-react";
import IconButton from "../../pieces/IconButton/IconButton";
import { AnimationDuration } from "../../../styles/Animations";
import { Transition } from "react-transition-group";
import forceReflow from "../../../utils/forceReflow";
import { Tick, Delete, Warning, Close, Information } from "../../icons";
import { ButtonSize } from "../../pieces/Button/Button";
export var NotificationType = /* @__PURE__ */ ((NotificationType2) => {
  NotificationType2["Success"] = "success";
  NotificationType2["Error"] = "error";
  NotificationType2["Delete"] = "delete";
  NotificationType2["Info"] = "info";
  return NotificationType2;
})(NotificationType || {});
let Notification = class extends React.Component {
  render() {
    return /* @__PURE__ */ React.createElement(
      Transition,
      {
        timeout: AnimationDuration.Long,
        in: this.props.isShowing,
        onEnter: forceReflow,
        unmountOnExit: true,
        mountOnEnter: true
      },
      (status) => /* @__PURE__ */ React.createElement("div", { className: `notification notification--${status}`, "aria-live": "polite" }, /* @__PURE__ */ React.createElement("div", { className: `notification__icon notification__icon--${this.props.type} center` }, this.renderIcon), /* @__PURE__ */ React.createElement("div", { className: "notification__body" }, this.props.children), /* @__PURE__ */ React.createElement("div", { className: "notification__close" }, /* @__PURE__ */ React.createElement(
        IconButton,
        {
          icon: /* @__PURE__ */ React.createElement(Close, null),
          "aria-label": "Close notification",
          onClick: this.props.onClose,
          size: ButtonSize.Small
        }
      )))
    );
  }
  get renderIcon() {
    if (this.props.type === "success" /* Success */) {
      return /* @__PURE__ */ React.createElement(Tick, null);
    } else if (this.props.type === "delete" /* Delete */) {
      return /* @__PURE__ */ React.createElement(Delete, null);
    } else if (this.props.type === "error" /* Error */) {
      return /* @__PURE__ */ React.createElement(Warning, null);
    } else {
      return /* @__PURE__ */ React.createElement(Information, null);
    }
  }
};
Notification.defaultProps = {
  type: "info" /* Info */
};
Notification = __decorateClass([
  observer
], Notification);
export {
  Notification as default
};
